import React, { PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import ThumbnailList from './ThumbnailList';
import Statement from './Statement';
import styles from './Series.css';
import { seriesShape, workShape } from '../lib/shapes';

function Series(props, context) {
  const { series, works } = props;
  const images = works.map((work, index) => ({
    url: `/works/${work.id}`,
    imageInfo: work.images[0],
  }));

  return (
    <div styleName="wrapper">
      <h3 styleName="title">{ series.title }</h3>
      <ThumbnailList images={images} />
      <Statement text={series.statement} dropCap />
    </div>
  );
}

Series.propTypes = {
  series: seriesShape.isRequired,
  works: PropTypes.arrayOf(workShape),
};

export default CSSModules(Series, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/components/Series.js